interface IconProps {
    size?: number;
}

/**
 * Ping Identity mark — the Ping "P" roundel in Ping red. Used for the PingOne
 * directory provider.
 */
export default function PingIdentityIcon({ size = 16 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" fill="#B90C2C" />
            <path
                d="M9 6.5h4.1c2.3 0 3.9 1.5 3.9 3.7s-1.6 3.8-3.9 3.8h-1.9v3.5H9V6.5Zm2.2 1.9v3.5h1.6c1 0 1.7-.7 1.7-1.75S13.8 8.4 12.8 8.4h-1.6Z"
                fill="#fff"
            />
        </svg>
    );
}
